exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-sort-icon svg{height:10px!important}.highlights-head{width:26px!important;cursor:pointer}.highlights-wrapper .highlights-section{height:100%!important;width:26px!important;padding:0}.highlighted-row{background:var(--bg-highlighted-row)!important}", ""]);

// exports
